import { useQuery } from '@tanstack/react-query'
import { axiosGet } from 'Redux/axiosHelper'
import { LeagueStandingResp } from 'types/league/leagueStandings'

const getLeagueStandings = async (leagueId: string) => {
  const response = await axiosGet(`v1/league-standings/${leagueId}`)
  return response.data
}

export const useGetLeagueStandings = (leagueId: string) => {
  const standings = useQuery<LeagueStandingResp>(
    ['league-standings-by-id', leagueId],
    () => getLeagueStandings(leagueId),
    // { enabled: false },
  )
  return standings
}
